import React from 'react'
export default function LevelAccessIcon() {
    return (
        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.77319 17V2.52002H8.95319V14.22H15.2932V17H5.77319Z" fill="black"/>
        </svg>

    )
}


